import React from 'react';
import logoLight from '../assets/logo-light-mode.png'; 
import logoDark from '../assets/logo-dark-mode.png'; 
// Eliminamos Facebook y Mail que no se usaban en el JSX
import { Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = ({ isDarkMode }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-50 dark:bg-[#050505] border-t border-slate-200 dark:border-white/5 pt-16 pb-8 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          
          {/* COLUMNA 1: LOGO E INFO */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src={isDarkMode ? logoDark : logoLight} 
                alt="Zento Logo" 
                className="h-8 w-auto object-contain"
              />
              <span className="text-xl font-black tracking-tighter text-slate-900 dark:text-white">
                ZENTO<span className="text-blue-600">.</span>
              </span>
            </div>
            <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed font-medium">
              La plataforma definitiva para dominar el desarrollo web y la inteligencia artificial con rutas claras y mentores expertos.
            </p>
          </div>

          {/* COLUMNA 2: PLATAFORMA */}
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white mb-6 uppercase text-xs tracking-widest">Plataforma</h3>
            <ul className="space-y-3 text-sm font-semibold text-slate-600 dark:text-slate-400">
              <li><a href="#rutas" className="hover:text-blue-600 transition-colors">Cursos</a></li>
              <li><a href="#beneficios" className="hover:text-blue-600 transition-colors">Beneficios</a></li>
              <li><a href="#opiniones" className="hover:text-blue-600 transition-colors">Testimonios</a></li>
              <li><a href="#faq" className="hover:text-blue-600 transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* COLUMNA 3: LEGAL */}
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white mb-6 uppercase text-xs tracking-widest">Legal</h3>
            <ul className="space-y-3 text-sm font-semibold text-slate-600 dark:text-slate-400">
              {/* href="#!" evita advertencias del linter sobre anchors vacíos */}
              <li><a href="#!" className="hover:text-blue-600 transition-colors">Privacidad</a></li>
              <li><a href="#!" className="hover:text-blue-600 transition-colors">Términos</a></li>
              <li><a href="#!" className="hover:text-blue-600 transition-colors">Cookies</a></li>
            </ul>
          </div>

          {/* COLUMNA 4: REDES SOCIALES */}
          <div>
            <h3 className="font-bold text-slate-900 dark:text-white mb-6 uppercase text-xs tracking-widest">Síguenos</h3>
            <div className="flex gap-3">
              <a href="#!" className="p-3 bg-slate-200 dark:bg-white/5 rounded-2xl hover:bg-blue-600 hover:text-white transition-all group">
                <Twitter className="w-5 h-5 transition-transform group-hover:scale-110" />
              </a>
              <a href="#!" className="p-3 bg-slate-200 dark:bg-white/5 rounded-2xl hover:bg-blue-600 hover:text-white transition-all group">
                <Instagram className="w-5 h-5 transition-transform group-hover:scale-110" />
              </a>
              <a href="#!" className="p-3 bg-slate-200 dark:bg-white/5 rounded-2xl hover:bg-blue-600 hover:text-white transition-all group">
                <Linkedin className="w-5 h-5 transition-transform group-hover:scale-110" />
              </a>
            </div>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="border-t border-slate-200 dark:border-white/5 pt-8 text-center">
          <p className="text-slate-500 dark:text-slate-600 text-xs font-bold uppercase tracking-widest">
            © {currentYear} ZENTO INC. TODOS LOS DERECHOS RESERVADOS.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;